import { bl_fi_mst_entity_vehicle_engine_RowClass } from '../../../dbschema/bl_fi_mst_entity_vehicle_engine.model';
import {BaseContainerModel} from '../../base-container.model';


export class VehicleEngineContainerModel extends BaseContainerModel {
bl_fi_mst_entity_vehicle_engine: bl_fi_mst_entity_vehicle_engine_RowClass = new bl_fi_mst_entity_vehicle_engine_RowClass();
}
